package er.prateek.crossly.share

internal fun jsHref(): String = js("(typeof window !== 'undefined' && window.location) ? String(window.location.href) : ''")

internal fun jsUserAgent(): String = js("(typeof navigator !== 'undefined' && navigator.userAgent) ? String(navigator.userAgent) : ''")

internal fun jsLanguage(): String = js("(typeof navigator !== 'undefined' && navigator.language) ? String(navigator.language) : ''")

internal fun jsReferrer(): String = js("(typeof document !== 'undefined' && document.referrer) ? String(document.referrer) : ''")

internal fun jsInnerWidth(): Int = js("(typeof window !== 'undefined' && window.innerWidth) ? window.innerWidth : 0")

internal fun jsInnerHeight(): Int = js("(typeof window !== 'undefined' && window.innerHeight) ? window.innerHeight : 0")

internal fun jsTzOffset(): Int = js("(typeof Date !== 'undefined') ? new Date().getTimezoneOffset() : 0")

internal fun jsAssign(url: String): Unit = js("window.location.assign(url)")

internal fun jsShareText(text: String): Unit = js(
    "(function(t){var w=typeof window!=='undefined'?window:null;var n=typeof navigator!=='undefined'?navigator:null;if(!n)return;if(n.share){if(w&&w.__crosslyShareInFlight)return;if(w)w.__crosslyShareInFlight=true;n.share({text:t}).then(function(){if(w)w.__crosslyShareInFlight=false},function(){if(w)w.__crosslyShareInFlight=false});return}if(n.clipboard&&n.clipboard.writeText){n.clipboard.writeText(t).catch(function(){})}})(text)",
)
